import axios from '../axios';

const getProjectTelegramUserAccounts = async (projectId: string) => {
  const { data } = await axios.get(`/business-accounts/${projectId}`);

  return data;
};

export default getProjectTelegramUserAccounts;
